<template>
  <div>
    <transition name="slideDown">
      <div class="splash-screen" v-show="this.$store.getters.getLoadingState">
        <div class="loader">
          <img :src="logo" class="logo-splash"/>
        </div>
      </div>
    </transition>
    <app-nav></app-nav>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Nav from "./components/NavBar.vue";
import Footer from "./components/footer.vue";
import '../node_modules/leaflet-geosearch/dist/geosearch.css';
import logo from './assets/images/logo_splash.png';
export default {
     data: function() {
      return {
        logo
      }
    }, 
    components:{
        appNav:Nav,
        appFooter:Footer
      }
}

</script>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  @import './assets/css/style.css';
  @import '~animate.css/source/_base.css';
  
</style>



// WEBPACK FOOTER //
// src/App.vue